import { all, fork } from "redux-saga/effects";
import accounts from "./accounts";
import session from "./session";
import users from "./users";

export default function* rootSaga() {
  yield all([fork(session), fork(accounts), fork(users)]);
}
